import { render, staticRenderFns } from "./CardLabelsV2.vue?vue&type=template&id=4676b63a&scoped=true&"
import script from "./CardLabelsV2.vue?vue&type=script&lang=js&"
export * from "./CardLabelsV2.vue?vue&type=script&lang=js&"
import style0 from "./CardLabelsV2.vue?vue&type=style&index=0&id=4676b63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676b63a",
  null
  
)

export default component.exports